export const purchaseUrls = {
  base: 'https://www.compradigitalya.com/cart/43034755792967:1',
  premium: 'https://www.compradigitalya.com/cart/43034757005383:1',
}

export const mockupUrl =
  'https://cdn.magicpatterns.com/uploads/5NH38MNwMogjdkY3RGSJ37/heylloyd-image-1785718337768.png'

export const testimonials = [
  {
    initials: 'VR',
    name: 'Valeria R.',
    place: 'Córdoba, Argentina · 34 años · Acompañante Terapéutica',
    text: 'Lo compré el miércoles y el jueves llegué a la sesión con una estructura que nunca había tenido. Abrí el tomo del diagnóstico, elegí dos intervenciones y completé el registro en cinco minutos. Terminé el día sin esa sensación horrible de haber improvisado todo.',
  },
  {
    initials: 'DS',
    name: 'Diego S.',
    place: 'Buenos Aires, Argentina · 38 años · AT hace 4 años',
    text: 'Tenía un paciente con esquizofrenia y no sabía cómo intervenir sin pasarme del rol. Con el Tomo 4 encontré el encuadre exacto: qué me corresponde, qué no y cómo comunicarlo al equipo. Hoy la psiquiatra me consulta antes de ajustar el plan.',
  },
  {
    initials: 'NG',
    name: 'Natalia G.',
    place: 'Rosario, Argentina · 41 años · AT independiente',
    text: 'Los formularios de informe cambiaron todo. Una auditora de obra social me dijo que mis registros eran los más completos que había visto de un AT. Nunca más me rechazaron una rendición ni me pidieron reescribir un informe.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Evaluación inicial y planificación del acompañamiento',
    period: 'La base clínica de todo el sistema',
    content: [
      'Guion completo de primera entrevista con paciente, familia y equipo tratante.',
      'Instrumentos de evaluación funcional listos para completar en la sesión 1.',
      'Definición de objetivos por nivel funcional: básico, intermedio y avanzado.',
      'Planificación trimestral con criterios objetivos de progresión.',
      'Encuadre inicial: horarios, límites, honorarios y acuerdos por escrito.',
    ],
  },
  {
    icon: '📗',
    name: 'Intervenciones y técnicas terapéuticas por diagnóstico',
    period: 'Qué hacer, cuándo y por qué',
    content: [
      'Intervenciones específicas para TEA, TDAH, esquizofrenia, bipolaridad, Alzheimer y consumo.',
      'Protocolo de actuación ante crisis, ideación de riesgo y desregulación severa.',
      'Técnicas de contención verbal y regulación emocional paso a paso.',
      'Cómo sostener la progresión sesión a sesión sin repetir siempre lo mismo.',
      'Criterios claros para saber cuándo una intervención debe cambiar.',
    ],
  },
  {
    icon: '📙',
    name: 'Trabajo profesional con familias y encuadre del rol',
    period: 'El límite que te protege',
    content: [
      'Cómo presentar el rol de AT a la familia en la primera reunión.',
      'Qué te corresponde y qué NO te corresponde: el mapa del rol sin zonas grises.',
      'Manejo de familias demandantes, ausentes o que invalidan el trabajo.',
      'Guiones concretos para conversaciones difíciles y pedidos fuera de rol.',
      'Acuerdos escritos con la familia listos para imprimir y firmar.',
    ],
  },
  {
    icon: '📕',
    name: 'Domicilio, escuela, hospital e instituciones',
    period: 'Un protocolo por contexto',
    content: [
      'Protocolo completo de acompañamiento en domicilio: entrada, sesión y cierre.',
      'Inclusión escolar: articulación con docentes, directivos y equipo de orientación.',
      'Acompañamiento en internación y guardia: rol, límites y comunicación.',
      'Institución y centro de día: encuadre, registro y trabajo en equipo.',
      'Qué llevar, qué registrar y cómo cerrar cada tipo de sesión.',
    ],
  },
  {
    icon: '📓',
    name: 'Comunicación con el equipo, informes y ética profesional',
    period: 'El respaldo que te falta',
    content: [
      'Modelos de informe mensual, trimestral y de cierre listos para completar.',
      'Cómo escribir para obra social y auditoría sin que te cuestionen el registro.',
      'Comunicación efectiva con psicólogo, psiquiatra, terapista y escuela.',
      'Ética profesional: confidencialidad, consentimiento y límites legales.',
      'Registro diario de sesión que se completa en cinco minutos.',
    ],
  },
  {
    icon: '📔',
    name: '50 casos clínicos completos desarrollados paso a paso',
    period: 'De la teoría a la sesión real',
    content: [
      '50 casos reales por diagnóstico, edad y contexto de intervención.',
      'Cada caso con evaluación inicial, plan, intervenciones y evolución.',
      'Errores frecuentes documentados y cómo evitarlos.',
      'Casos de crisis resueltos con el protocolo aplicado paso a paso.',
      'Modelos de informe reales asociados a cada caso.',
    ],
  },
]

export const bonuses = [
  [
    '01',
    '🎯',
    '+300 actividades terapéuticas clasificadas por diagnóstico',
    'Actividades listas para aplicar, organizadas por diagnóstico, edad y objetivo terapéutico. Con materiales necesarios, duración estimada y criterios de progresión para que nunca más entres a una sesión sin saber qué hacer.',
    '$12.000',
  ],
  [
    '02',
    '🎮',
    '+200 juegos terapéuticos con instrucciones completas',
    'Juegos para vínculo, atención, autonomía, lenguaje y regulación emocional. Cada uno con instrucciones completas, variantes por nivel funcional y adaptaciones para domicilio, escuela e institución.',
    '$10.000',
  ],
  [
    '03',
    '🧩',
    'Estimulación cognitiva profesional lista para imprimir',
    'Ejercicios de memoria, atención, funciones ejecutivas, orientación y lenguaje en tres niveles de dificultad. Ideal para adultos mayores, Alzheimer y deterioro cognitivo. Imprimís y trabajás.',
    '$12.000',
  ],
  [
    '04',
    '🖨️',
    'Material imprimible: pictogramas, rutinas, tableros y organizadores',
    'Pictogramas, secuencias de rutina, tableros de comunicación, agendas visuales y organizadores diarios. Todo en alta calidad, listo para imprimir y usar en la próxima sesión.',
    '$14.000',
  ],
  [
    '05',
    '🔬',
    'Recursos por diagnóstico: TEA, TDAH, Alzheimer, esquizofrenia y más',
    'Fichas técnicas por diagnóstico con signos de alerta, intervenciones recomendadas, qué evitar y cómo comunicarte con el equipo tratante. Tu referencia rápida antes de cada sesión.',
    '$12.000',
  ],
  [
    '06',
    '📋',
    'Formularios profesionales completos listos para usar',
    'Registro diario, informe mensual, informe de cierre, consentimientos, acuerdos con la familia, planilla de objetivos y planilla de asistencia. Los mismos formularios que las auditorías aprueban sin observaciones.',
    '$12.000',
  ],
] as const

export const faqs = [
  [
    '¿Sirve si recién empiezo en Acompañamiento Terapéutico?',
    'Sí, y es uno de los usos más frecuentes. El Tomo 1 te da toda la base clínica para llegar preparada a tu primera entrevista: guion de evaluación inicial, instrumentos para completar, definición de objetivos y encuadre por escrito. Podés empezar desde cero sin experiencia previa.',
  ],
  [
    '¿Cómo recibo el material?',
    'Al completar el pago recibís un correo electrónico con el acceso a todos los PDF en menos de cinco minutos. Son archivos descargables, sin vencimiento y sin plataforma que caduque: el material queda tuyo para siempre.',
  ],
  [
    '¿Funciona para domicilio, escuela e institución?',
    'Sí. El Tomo 4 tiene protocolos específicos para cada contexto: domicilio, inclusión escolar, hospital e internación, e institución o centro de día. Cada uno con encuadre, qué llevar, cómo intervenir y cómo registrar la sesión.',
  ],
  [
    '¿La garantía es real?',
    'Completamente real. Tenés siete días desde la compra para revisar todo el material. Si sentís que no era lo que esperabas, escribís a compradigitalyaa@gmail.com y te devolvemos el 100% del dinero. Sin formularios, sin preguntas, sin vueltas.',
  ],
  [
    '¿Incluye protocolos para crisis y situaciones de riesgo?',
    'Sí. El Tomo 2 incluye el protocolo de actuación ante crisis, ideación de riesgo y desregulación severa, paso a paso y en orden de prioridad. El Mega Kit de Intervención amplía con protocolos de actuación crítica y guiones de comunicación urgente al equipo tratante.',
  ],
  [
    '¿Los informes sirven para obra social y auditoría?',
    'Sí. El Tomo 5 y el Bono 6 traen modelos de registro diario, informe mensual, informe trimestral y de cierre redactados con el lenguaje técnico que las auditorías esperan. Solo completás los datos del paciente y la evolución.',
  ],
  [
    '¿Sirve para pacientes de todas las edades?',
    'Sí. Hay recursos e intervenciones para infancias, adolescencia, adultos y adultos mayores, incluyendo TEA, TDAH, esquizofrenia, bipolaridad, consumo problemático, Alzheimer y deterioro cognitivo.',
  ],
  [
    '¿Qué necesito para usarlo?',
    'Solo un dispositivo para leer PDF: celular, tablet o computadora. Todos los formularios, pictogramas y planillas están optimizados para imprimir en hoja A4 si preferís trabajar en papel.',
  ],
  [
    '¿Cuál es la diferencia con el Mega Kit de Intervención?',
    'El Combo Completo son los 6 Tomos más los 6 Bonos. El Mega Kit de Intervención agrega 50 páginas de intervención avanzada: +500 intervenciones clasificadas por diagnóstico, protocolos de actuación crítica, planificaciones maestras de 30, 60 y 90 días y el banco de objetivos técnicos por nivel funcional.',
  ],
  [
    '¿Puedo usarlo para presentar mi trabajo al equipo interdisciplinario?',
    'Sí, es exactamente para lo que fue diseñado. Los informes, el banco de objetivos y el registro de progresión te permiten mostrar el trabajo con criterio técnico y sostener tu lugar en el equipo con datos, no con impresiones.',
  ],
] as const

export const recentPurchases = [
  ['Valeria R.', 'Córdoba', 'Combo Completo AT'],
  ['Diego S.', 'Buenos Aires', 'Combo Completo + Mega Kit de Intervención'],
  ['Natalia G.', 'Rosario', 'Combo Completo AT'],
  ['Carolina M.', 'Mendoza', 'Combo Completo + Mega Kit de Intervención'],
  ['Lucía F.', 'Mar del Plata', 'Combo Completo AT'],
  ['Sofía P.', 'La Plata', 'Combo Completo + Mega Kit de Intervención'],
  ['Martín A.', 'Salta', 'Combo Completo AT'],
  ['Romina L.', 'Neuquén', 'Combo Completo AT'],
  ['Julieta B.', 'San Miguel de Tucumán', 'Combo Completo + Mega Kit de Intervención'],
  ['Ezequiel C.', 'Bahía Blanca', 'Combo Completo AT'],
] as const
